import { isSameOrContains } from 'anodum';
import bowser from 'yola-bowser';
import view from '../../view';
import { connectedStore } from '../../store';

import text from '../injections/bindings/text';
import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import { IMAGE_SELECTOR } from '../constants/image-selector';

const elementFocusHandler = (event) => {
  const { target } = event;

  if (!instance.driver.referenceMap.hasReference(target)) {
    return;
  }

  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);
  const currentFocusedElement = getLiveElement(focusedElementId);

  if (isSameOrContains(currentFocusedElement, target)) {
    return;
  }

  if (currentFocusedElement) {
    store.dispatch(view.actions.blurFocusedElement({ preserveFocusedTextElement: true }));
  }

  const selectedElementId = view.selectors.getSelectedElement(state);
  const selectedElement = view.accessors.getLiveElement(selectedElementId);

  const textElement = text.getRootTextElement(target);

  if (!textElement) {
    return;
  }

  // when user clicks on image inside text element like in Article block we remove node
  // ref-id attributes that means we've corrupted data provided to `dispatchSelectedElementEvent` which we've fired couple of seconds
  // before this handler in `element-select-handler` cuz now element id is not valid so we don't need to focus element in case user
  // clicked on image nested inside text element to keep correct ref-id.
  if (
    selectedElement &&
    selectedElement.closest(IMAGE_SELECTOR) &&
    isSameOrContains(target, selectedElement)
  ) {
    textElement.blur();
    return;
  }

  // on android devices element is focused even with [contenteditable="false"] attribute
  // for ex., <a> tag
  if (bowser.android && textElement.getAttribute('contenteditable') === 'false') {
    target.blur();
    return;
  }

  const elementId = instance.driver.referenceMap.getReferenceId(textElement);
  instance.driver.removeAllTextInjections(textElement);
  store.dispatch(view.actions.setSelectedElement(null));
  store.dispatch(view.actions.setFocusedElement(elementId));
};

export default elementFocusHandler;
